export class IntersectionInspect {
  constructor(options) {
    this._io = new IntersectionObserver((entry) => {
      entry.forEach((item) => {
        const intersectChange = this._intersectionEvent.get(item.target)
        intersectChange && intersectChange(item)
      })
    }, options)
    this._intersectionEvent = new Map()
  }
  observe(el, intersectChange) {
    this._io.observe(el)
    this._intersectionEvent.set(el, intersectChange)
  }
  unobserve(el) {
    this._io.unobserve(el)
    this._intersectionEvent.delete(el)
  }
}

export default new IntersectionInspect()
